module.exports = __webpack_public_path__ + "static/media/articles.02cc1a24.jpg";